module.exports = __webpack_public_path__ + "img/bold.eabb545a.png";